import React from 'react';
import { Link } from 'react-router-dom';
import { chunk, last } from 'lodash';

export const createPaginationChunks = (total = 0, split = 0) => {
  const collection = [...new Array(total)].map((_, index) => index + 1);
  return chunk(collection, split);
};

export const spreadChunk = (current, total) => {
  const collection = [...new Array(total)].map((_, index) => index + 1);
  const lastItem = collection.length + 1;

  if (current === 1 || current === 2) {
    return collection.slice(0, 4);
  }

  if (current === lastItem) {
    return collection.slice(current - 4, current);
  }

  return collection.slice(current - 3, current + 2);
};

export const SpreadPages = ({ count, current, url }) => {
  const split = count >= 10 ? Math.round(count / 10) : 1;
  const chunks = createPaginationChunks(count, split);
  const innerChunk = spreadChunk(current, count);
  const pages = chunks.map((chunk, index) => {
    return {
      chunk,
      page: index === chunks.length ? chunk[0] : last(chunk),
    };
  });

  return pages.map(({ chunk, page }) => {
    if (chunk.includes(current)) {
      return innerChunk.map((item) => (
        <li key={item} className={current === item ? 'active' : ''}>
          <Link to={url(item)}>{item}</Link>
        </li>
      ));
    }

    if (innerChunk.includes(page)) {
      return null;
    }

    return (
      <li key={page}>
        <Link to={url(page)}>{page}</Link>
      </li>
    );
  });
};

const Pagination = ({ count, current, url, hideIfOnePage = true }) => {
  if (!count || !current || typeof url !== 'function') {
    return null;
  }

  if (hideIfOnePage && count <= 1) {
    return null;
  }

  const firstPage = 1;
  const lastPage = typeof count === 'number' ? count : parseInt(count, 10);
  const currentPage =
    typeof current === 'number' ? current : parseInt(current, 10);

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination">
        <li className={currentPage === firstPage ? 'disabled' : ''}>
          <Link to={url(firstPage)}>First</Link>
        </li>
        <SpreadPages count={lastPage} current={currentPage} url={url} />
        <li className={currentPage === lastPage ? 'disabled' : ''}>
          <Link to={url(lastPage)}>Last</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
